"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWeb3React = exports.Web3ReactProvider = void 0;

var react_1 = __importStar(require("react"));

var hooks_1 = require("./hooks");

var Web3Context = (0, react_1.createContext)(undefined);

function Web3ReactProvider(_ref) {
  var children = _ref.children,
      connectors = _ref.connectors,
      network = _ref.network,
      _ref$lookupENS = _ref.lookupENS,
      lookupENS = _ref$lookupENS === void 0 ? true : _ref$lookupENS;

  var _ref2 = (0, hooks_1.getPriorityConnector).apply(void 0, _toConsumableArray(connectors)),
      usePriorityConnector = _ref2.usePriorityConnector,
      usePriorityChainId = _ref2.usePriorityChainId,
      usePriorityAccounts = _ref2.usePriorityAccounts,
      usePriorityIsActivating = _ref2.usePriorityIsActivating,
      usePriorityError = _ref2.usePriorityError,
      usePriorityAccount = _ref2.usePriorityAccount,
      usePriorityIsActive = _ref2.usePriorityIsActive,
      usePriorityProvider = _ref2.usePriorityProvider,
      usePriorityENSNames = _ref2.usePriorityENSNames,
      usePriorityENSName = _ref2.usePriorityENSName;

  var connector = usePriorityConnector();
  var chainId = usePriorityChainId();
  var accounts = usePriorityAccounts();
  var isActivating = usePriorityIsActivating();
  var error = usePriorityError();
  var account = usePriorityAccount();
  var isActive = usePriorityIsActive();
  var provider = usePriorityProvider(network);
  var ENSNames = usePriorityENSNames(lookupENS ? provider : undefined);
  var ENSName = usePriorityENSName(lookupENS ? provider : undefined);
  return react_1.default.createElement(Web3Context.Provider, {
    value: {
      connector: connector,
      chainId: chainId,
      accounts: accounts,
      isActivating: isActivating,
      error: error,
      account: account,
      isActive: isActive,
      provider: provider,
      ENSNames: ENSNames,
      ENSName: ENSName
    }
  }, children);
}

exports.Web3ReactProvider = Web3ReactProvider;

function useWeb3React() {
  var web3 = (0, react_1.useContext)(Web3Context);
  if (!web3) throw Error('useWeb3React can only be used within the Web3ReactProvider component');
  return web3;
}

exports.useWeb3React = useWeb3React;